import { Button } from "@/components/ui/button"
import { List, X } from "@phosphor-icons/react"
import { useState } from "react"
import { Link, useNavigate } from "react-router-dom"
import logo from "@/assets/images/zoe-fc-logo.jpeg"

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const navigate = useNavigate()

  const navigation = [
    { name: "Home", href: "/" },
    { name: "About", href: "/about" },
    { name: "Programs", href: "/programs" },
    { name: "International", href: "/international" },
    { name: "Events", href: "/events" },
    { name: "Contact", href: "/contact" },
  ]

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-navy border-b border-ivory/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-3 hover:opacity-90 transition-opacity">
            <div className="w-16 h-16 rounded overflow-hidden bg-ivory">
              <img src={logo} alt="ZOE Football Academy" className="w-full h-full object-cover" />
            </div>
            {/* <span className="text-ivory text-lg font-semibold tracking-tight">
              ZOE Football Academy
            </span> */}
          </Link>

          <nav className="hidden md:flex items-center gap-8">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="text-ivory/80 hover:text-ivory text-sm font-medium transition-colors duration-200 relative group"
              >
                {item.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gold group-hover:w-full transition-all duration-200" />
              </Link>
            ))}
          </nav>

          <div className="hidden md:block">
            <Button 
              className="bg-gold text-navy hover:bg-gold/90 font-medium uppercase text-sm tracking-wide"
              onClick={() => navigate("/contact")}
            >
              Apply for Trials
            </Button>
          </div>

          <button
            className="md:hidden text-ivory p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-navy-muted border-t border-ivory/10">
          <div className="px-4 py-6 space-y-4">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className="block text-ivory text-base font-medium py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                {item.name}
              </Link>
            ))}
            <Button 
              className="w-full bg-gold text-navy hover:bg-gold/90 font-medium uppercase text-sm tracking-wide"
              onClick={() => {
                setMobileMenuOpen(false)
                navigate("/contact")
              }}
            >
              Apply for Trials
            </Button>
          </div>
        </div>
      )}
    </header>
  )
}
